/**
 * Used this component to added links or info into top right header
 * Mobile version: under social links
 */

import React from 'react';
import { HeaderTopRightMoreMuseum } from 'iovisit-museum-theme/components';

const HeaderTopRightMore = () => {
  return <HeaderTopRightMoreMuseum />;
};

export default HeaderTopRightMore;
